import React from 'react';
import { Zap } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="bg-dark-bg text-white py-20 px-4 md:px-8 relative overflow-hidden" data-id="element-133">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-orange/10 blur-[120px] rounded-full pointer-events-none" data-id="element-134"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-135">
        <div className="inline-flex items-center justify-center p-4 bg-dark-surface rounded-full mb-8 border border-brand-orange/30" data-id="element-136">
          <Zap className="w-8 h-8 text-brand-orange" data-id="element-137" />
        </div>
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-8 uppercase" data-id="element-138">
          El interruptor que{' '}
          <span className="text-brand-orange" data-id="element-139">nadie te mostró</span>
        </h2>
        <div className="font-inter text-lg md:text-xl text-gray-300 space-y-6 leading-relaxed text-left max-w-3xl mx-auto" data-id="element-140">
          <p data-id="element-141">
            Tu grasa abdominal no responde a calorías. Responde a señales
            hormonales.
          </p>
          <p data-id="element-142">
            Cuando la insulina está alta, tu cuerpo está en modo almacenamiento.
            No importa cuánto corras. No importa cuánto te prives.
          </p>
          <p className="text-white font-semibold" data-id="element-143">
            El Protocolo Cero Panza 14 trabaja sobre un principio simple:
          </p>
          <p data-id="element-144">
            Bajar la insulina basal. Activar la oxidación de grasa visceral.
            Sostenerlo 14 días consecutivos.
          </p>
          <p className="text-white font-semibold text-xl md:text-2xl text-center mt-8 border-y border-gray-800 py-8" data-id="element-145">
            No es magia. Es bioquímica aplicada a la vida real de un hombre
            ocupado.
          </p>
          <p className="text-center" data-id="element-146">
            5 minutos de activación en ayunas. Orden de comidas específico.
            Lista de alimentos que no te sacan lo que más disfrutás.
          </p>
          <p className="text-brand-orange font-semibold text-center" data-id="element-147">
            El asado sigue en el menú. Lo que cambia es todo lo demás.
          </p>
        </div>
      </div>
    </section>;
}